module.exports = import("https://cdn.jsdelivr.net/npm/zero-md@3");;